<template>
  <div @click="pickColor"></div>
</template>

<script>
export default {
  name: 'color',
  props: {
    color: {
      type: String,
      default: '#ffffff',
    },
  },
  methods: {
    pickColor() {
      this.$emit('pick-color', this.color);
    },
  },
};
</script>

<style lang="scss"></style>
